module.exports = __webpack_public_path__ + "static/media/hausify_transparent.b436e402.png";